import { render, staticRenderFns } from "./LoadingIndicator.vue?vue&type=template&id=712356e8&lang=pug"
var script = {}
import style0 from "./LoadingIndicator.vue?vue&type=style&index=0&id=712356e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports